import { useEffect, useState } from "react";
import Input from "../../components/input";
import Button from "../../components/button";
import { useDispatch, useSelector } from "react-redux";
import phoneIcon from "../../assets/icons/phone.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updatePassword } from "../../hooks/local/reducer";
import { showErrorMessage, showSuccessMessage } from "../../hooks/constants";

const Profile = ({setPageTitle}) => {
    useEffect(() => {
        setPageTitle("Profile");
        document.title="User profile - Mosquepay"
      },[setPageTitle]);

      const [selectedProfileSetting, setSelectedProfileSetting] = useState("Update password");

      const userSessionData = useSelector((state) => state.user.userSession);
      
      const userName = userSessionData?.user_details[0].username;
      const userEmail = userSessionData?.user_details[0].email;
      const phone = userSessionData?.user_details[0].phonenumber;

      const dispatch = useDispatch();

      const loading = useSelector((state) => state.user.loading);

      const updatePasswordForm = useFormik({
        initialValues: {
          email: "",
          phonenumber: "",
          old_password: "",
          new_password: "",
          confirm_password: "",
        },
        validationSchema: Yup.object({
          new_password: Yup.string()
            .required("Password cannot be empty")
            ,
          confirm_password: Yup.string()
            .required("Confirm Password!")
            .oneOf([Yup.ref("new_password"), null], "Passwords must match"),
        }),
        onSubmit: async (values, {resetForm}) => {
          const {old_password, new_password} = values;
          let updatePasswordData = {email:userEmail, phonenumber:phone, old_password, new_password};
          const payload = await dispatch(updatePassword(updatePasswordData));
          if(payload.status_code === "0"){
            showSuccessMessage("Password Updated!")
            resetForm();
          }
        }
      });


  
    return (
      <div>
        <div className="grid">
          <span className="font-semibold">Profile.</span>
          <span className="text-secondary text-sm">
            Manage your mosquepay account
          </span>
        </div>
        <div className="grid md:flex items-center gap-4 my-6">
          <div className="h-16 w-16 rounded-full border-2 border-dashed bg-brandGreen/5 border-brandGreen text-brandGreen text-lg font-semibold flex items-center justify-center">
            {userName.charAt(0)}
          </div>
          <div>
            <p className="text font-semibold">{userName}</p>
            <p className="text-sm text-secondary">{userEmail}</p>
            <div className="flex items-center gap-2 mt-3">
              <img src={phoneIcon} alt="" className="h-4" />
              <p className=" text-secondary text-sm">{phone}</p>
            </div>
          </div>
        </div>
        <div>
          <div className=" overflow-x-auto whitespace-nowrap mb-6">
            <div className="flex text-sm bg-white border rounded py-3 w-fit divide-x">
              <span
                className={`px-4 cursor-pointer ${
                  selectedProfileSetting === "Update password"
                    ? "text-brandGreen font-semibold"
                    : ""
                }`}
                onClick={() => setSelectedProfileSetting("Update password")}
              >
                Update password
              </span>
              <span
                className={`px-4 cursor-pointer ${
                  selectedProfileSetting === "Report an issue"
                    ? "text-brandGreen font-semibold"
                    : ""
                }`}
                onClick={() => setSelectedProfileSetting("Report an issue")}
              >
                Report an issue
              </span>
            </div>
          </div>
          {/* update password */}
          {selectedProfileSetting === "Update password" && (
            <form onSubmit={updatePasswordForm.handleSubmit} className="grid gap-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <Input
                  type={"password"}
                  isPassword={"true"}
                  label={"Old password"}
                  name={"old_password"}
                  value={updatePasswordForm.values.old_password}
                  onChange={updatePasswordForm.handleChange}
                  onBlur={updatePasswordForm.handleBlur}
                  onError={updatePasswordForm.touched.old_password && updatePasswordForm.errors.old_password
                    ? updatePasswordForm.errors.old_password
                    : null}
                />
                <Input
                  type={"password"}
                  isPassword={"true"}
                  label={"New password"}
                  name={"new_password"}
                  value={updatePasswordForm.values.new_password}
                  onChange={updatePasswordForm.handleChange}
                  onBlur={updatePasswordForm.handleBlur}
                  onError={updatePasswordForm.touched.new_password && updatePasswordForm.errors.new_password
                    ? updatePasswordForm.errors.new_password
                    : null}
                />
                <Input
                  type={"password"}
                  isPassword={"true"}
                  label={"Confirm password"}
                  name={"confirm_password"}
                  value={updatePasswordForm.values.confirm_password}
                  onChange={updatePasswordForm.handleChange}
                  onBlur={updatePasswordForm.handleBlur}
                  onError={updatePasswordForm.touched.confirm_password && updatePasswordForm.errors.confirm_password
                    ? updatePasswordForm.errors.confirm_password
                    : null}
                />
              </div>
              <Button
                buttonText={"Update password"}
                otherStyles={"bg-black text-white"}
                loading={loading}
              />
            </form>
          )}
          {/* report an issue */}
          {selectedProfileSetting === "Report an issue" && (
            <div className="grid gap-4">
              <textarea
                className="w-full md:w-1/2 px-4 py-5 md:py-4 border text-sm focus:outline focus:outline-brandGreen/50 rounded"
                name=""
                id=""
                rows={6}
                placeholder="Start typing..."
              ></textarea>
              <Button
                buttonRole={"submit"}
                buttonText={"Send message"}
                otherStyles={"bg-black text-white"}
              />
            </div>
          )}
        </div>
      </div>
    );
}
 
export default Profile;